import { Middleware } from '@nuxt/types';

const enforceReviewingGate: Middleware = context => {
  const isReviewingFeatureEnabled = context.store.getters['events/isReviewingFeatureEnabled'];
  if (!isReviewingFeatureEnabled) {
    const errorMessage = context.app.i18n.t('shared.error.server_validation.authorization_error');
    context.app.$toast.error(errorMessage);
    context.$auth.redirect('home');
  }
};

export default enforceReviewingGate;
